if(window.navigator.userAgent.match("phonepe-webview")!=null||((/AppContainer/i.test(window.navigator.userAgent))!=false))
    {       
      document.getElementsByClassName("purphide")[1].style.display="none";
      var pButtons = document.getElementsByClassName("purphide");
      for(var i=0; i<pButtons.length; i++) {
      pButtons[i].style.display="none";
  }
      document.getElementById('footer').getElementsByClassName('desktop-3 tablet-half mobile-3 xc')[0].style.display='none';
  }
if(window.navigator.userAgent.match("phonepe-webview")!=null||((/AppContainer/i.test(window.navigator.userAgent))!=false))
    {         
      try{
      	var zButton = document.getElementById("share-coupon-small");
      	zButton.setAttribute("style","display: none !important");
      }
      catch{
        }
          if (window.location.href.includes('/account')) {
          window.location.href = 'https://www.tekkitake.com/';
      }
     
  }
if(window.navigator.userAgent.match("phonepe-webview")!=null||((/AppContainer/i.test(window.navigator.userAgent))!=false))
    {         
      try{
      	var uButton = document.getElementById("messageus_button");
      	uButton.setAttribute("style","display: none !important");
      }
      catch{
        }
        if (window.location.href.includes('/account')) {
          window.location.href = 'https://tekkitake.myshopify.com/';
    	}
        if (window.location.href.includes('/orders')) {
          document.getElementsByClassName("content-box__row content-box__row--no-padding")[0].style.display = 'none';
    	}
      
        if (window.location.href.includes('/about-us')) {
          document.getElementsByTagName('p')[36].style.display="none";
          document.getElementsByTagName('h2')[2].style.display="none";
    	}
      	var share = setInterval(() => { 
          document.getElementById('share-coupon-small').style.display='none';
      	  clearInterval(share);
        }, 10);
      	var chatapp = setInterval(() => { 
          document.getElementById('shopify-chat').style.display='none';
      	  clearInterval(chatapp);
        }, 10);
      	var fc = setInterval(() => { 
          document.getElementById('fc_frame').style.display='none';
      	  clearInterval(fc);
        }, 1000);
      	var messageus_button = setInterval(() => { 
          document.getElementById('messageus_button').style.display='none';
      	  clearInterval(messageus_button);
        }, 10);  
      
  }
  
if(window.navigator.userAgent.match("phonepe-webview")!=null||((/AppContainer/i.test(window.navigator.userAgent))!=false))
    {      
      try{
      var sButton = document.getElementById("fc_frame");
      sButton.setAttribute("style","display: none !important");
      }
      catch{
        }
  }  
if(window.navigator.userAgent.match("phonepe-webview")!=null||((/AppContainer/i.test(window.navigator.userAgent))!=false))
    {      
      try{
      var sButton = document.getElementById("instagram-card");
      sButton.setAttribute("style","display: none !important");
      }
      catch{
        }
  }
  
if(window.navigator.userAgent.match("phonepe-webview")!=null||((/AppContainer/i.test(window.navigator.userAgent))!=false))
    {      
      try{
      var sButton = document.getElementsByClassName("sub-menuu")[0].getElementsByTagName("li")[6];
      sButton.setAttribute("style","display: none !important");
      }
      catch{
        }
  }
  
$(document).on('click', 'input[name="checkout"]', function (e){
     const ua = window.navigator.userAgent;
      let environment;
       if(ua.match("phonepe-webview")!= null){
          environment="phonepe"
        }
        else if((/AppContainer/i.test(ua))!=false){
          environment="paytm"
        }
      if(environment==="phonepe"||environment==="paytm"){
        e.preventDefault();
        $.ajax({

          url:'/cart.js',
          data:'',
          success:function(data,status,xhr){
              console.log(xhr.getResponseHeader("x-shopid"));
            let shopId=xhr.getResponseHeader("x-shopid");
            console.log('cart data', data);        
            items=data.items;
            if (items.length === 0 && (data.items_subtotal_price) === 0){
              window.location.href = "/cart";
            }
            else{
              let discountcode = null;
              if(data.cart_level_discount_applications.length){
                discountcode = data.cart_level_discount_applications[0].title
              }
              else{
   
                discountcodes=items.map(item =>  ({"discounts":item.discounts}));
                discountcodes.forEach(function(item){
                  if(item.discounts.length){
                    discountcode = item.discounts[0].title
                  }
                });
              }
              lineitems=items.map(item =>  ({"name":item.product_title,"sku":item.sku,"variantId":item.id,"qty":item.quantity,"mrp":item.original_price/100,"sellingPrice":item.final_price/100}));
              obj={
                "extId":data.token.toString(),
                "salesChannel":environment,
                "extStoreId":shopId,
                "amount":data.items_subtotal_price/100,
                "cartItems":lineitems,
                "discountCode":discountcode,
                "discountAmount":data.total_discount/100,
              }
              console.log(JSON.stringify(obj));
            sendData(obj,data.token,shopId);
           }

          },
          dataType:"json"

        })
        function sendData(obj1,cartId,shopId){
          obj1=JSON.stringify(obj1);
          $.ajax({

            type: "POST",
              async: true,
              crossDomain : true,
              url: 'https://backend-checkout.perpule.com/cart',
              dataType: "json",
              data: obj1,
              contentType: "application/json; charset=utf-8",
              statusCode:
              {
              200: function() {
                window.location.href=("https://checkout.perpule.com/?cartid="+cartId+"&shopid="+shopId);

              },
              }
          });
          }
      }
      else{
        /* Client Code  */
      }
})